import { useState } from "react";
import olOSMSource from "ol/source/OSM";
import { Tile } from "../../reactOL/layers";

const LightOsmTileLayer = () => {
  const [source] = useState(() => new olOSMSource());

  return <Tile source={source} />;
};

export default LightOsmTileLayer;
